import axios from '@/plugins/axios'

const getAssets = async ({ type, page = 1 }) => {
  try {
    const response = await axios.get('assets', {
      params: {
        type: type,
        page: page
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getAssets
}
